const header2Styles = theme => ({
  l_header: {
    ...theme.mixins.bg('cover', 'center', theme.palette.common.gray.darker),
  },
  l_headerContent: {
    minHeight: 95,
    width: '100%',
    ...theme.mixins.gridColumns(theme.spacing(1.5)),
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.palette.common.white,
    ...theme.mixins.paddingY(1.5),
    position: 'relative',
  },
  l_logo: {
    ...theme.mixins.gridColumns(theme.spacing(1.5)),
    alignItems: 'center',
    color: theme.palette.common.white,
  },
  icon: {
    ...theme.mixins.l_responsiveImage,
    height: 50,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    textShadow: '0 2px 4px rgba(0, 0, 0, .5)',
  },
  logoRight: {
    right: 0,
    height: 30,
    ...theme.mixins.l_responsiveImage,
  },
})

export default header2Styles
